import React from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import { SearchStyle } from '../styles'
import { PAGES } from '../navigation/routes'

const AttributionRules = () => {
    return (
        <Container sx={SearchStyle.container}>
            <Typography {...SearchStyle.title} gutterBottom>
                {PAGES.attributionRules.title}
            </Typography>
            <Typography {...SearchStyle.paragraph} gutterBottom>
                T-CAIREM's educational resources are free to use. Attribution
                guidelines for using these materials in your own courses and
                programs will be published here soon. In the meantime, please{' '}
                <Link href="mailto:tcairem.comms@utoronto.ca">
                    contact the T-CAIREM education team
                </Link>{' '}
                with any questions.
            </Typography>
        </Container>
    )
}

export default AttributionRules
